/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=45ea9bf8"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "D:\\源码\\frontend\\vue-wms-mobile-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__